import { defineActions } from './defineActions'

/**
 * Cross-cutting actions: controls shared by every section and module (email tracking, file
 * upload fields). Action names start with Common.; the module comes from the page's subject.
 */
export const commonActions = defineActions({
  'Common.EmailTracking.Resend': {
    label: 'Retry email',
    area: 'Emails',
    description: 'Retry in the Email Message modal: sends the email again.',
  },
  'Common.EmailTracking.SyncStatus': {
    label: 'Sync email status',
    area: 'Emails',
    description:
      'Sync Email Status in the Email Message modal or the Email Tracking Info table.',
  },
  'Common.File.Upload': {
    label: 'Upload file',
    area: 'Files',
    description:
      'Files picked or dropped on an upload field (one entry per batch). Most fields link the file to the case on the section Save.',
  },
  'Common.File.UploadLabelled': {
    label: 'Upload labelled file',
    area: 'Files',
    description:
      'Upload labelled file: the Microsoft Purview protection is removed on upload.',
  },
  'Common.File.Remove': {
    label: 'Delete file',
    area: 'Files',
    description:
      'Delete on a file row, confirmed. Most fields remove the file on the section Save.',
  },
  'Common.File.RemoveAll': {
    label: 'Remove all files',
    area: 'Files',
    description:
      'Remove All in the file list, confirmed. Most fields remove the files on the section Save.',
  },
  'Common.Attachment.Cleanup': {
    label: 'Clean up file',
    area: 'Files',
    description: 'Removes duplicate and blank pages from a saved attachment.',
  },
  'Common.Attachment.Summarize': {
    label: 'View document summary',
    area: 'Files',
    description:
      'View Summary on a PDF: the AI summary is generated and stored the first time.',
  },
})
